/* E-bike kits are actual purchase variants; never rewrite a helmet option ID. */
(function (global) {
  'use strict';
  if (global.LumosEbikeBundles) return;

  function bind(owner) {
    var form = owner.element.querySelector('form[action*="/cart/add"]');
    var marker = form && form.querySelector('[data-lumos-ebike-bundles]');
    if (!marker || owner._lumosEbikeBundlesBound) return;
    owner._lumosEbikeBundlesBound = true;
    var inputs = Array.from(form.querySelectorAll('[data-ebike-bundle]'));
    var nativeResolve = owner._getCurrentVariantFromOptions;
    var nativeHistory = owner._updateHistoryState;
    var nativePrices = owner._updateProductPrices;
    var nativeInventory = owner._updateInventory;
    var master = owner.masterSelector;

    function options(input) {
      var item = input.closest('li');
      return item ? Array.from(item.querySelectorAll('.hidden-selector option')) : [];
    }
    function parse(option) {
      try {
        var value = JSON.parse(option.getAttribute('data-variant-json'));
        if (!value || !Number.isSafeInteger(value.id) || value.id <= 0 ||
            String(value.id) !== option.value || typeof value.available !== 'boolean' ||
            !Number.isSafeInteger(value.price) || value.price < 0 ||
            (value.compare_at_price != null && (!Number.isSafeInteger(value.compare_at_price) || value.compare_at_price < 0))) return null;
        return value;
      } catch (_) { return null; }
    }
    var entries = [];
    inputs.forEach(function (input) {
      options(input).forEach(function (option) {
        var variant = parse(option);
        if (!variant) return;
        // Duplicate/conflicting IDs are never allowed to overwrite native choices.
        if (master.querySelector('option[value="' + variant.id + '"]')) return;
        var added = option.cloneNode(true);
        added.removeAttribute('selected');
        added.setAttribute('data-value-original', String(variant.id));
        master.appendChild(added);
        entries.push({ input: input, option: option, master: added });
      });
    });

    owner._getCurrentVariantFromOptions = function () {
      var selected = inputs.filter(function (input) { return input.checked; });
      if (!selected.length) return nativeResolve.apply(this, arguments);
      if (selected.length !== 1 || selected[0].disabled) return null;
      var input = selected[0];
      var color = form.querySelector('input[name="option-0"]:checked');
      var size = form.querySelector('input[name="option-2"]:checked');
      if (!color || !size) return null;
      function sizeKey(value) { return String(value || '').split(' ')[0].toUpperCase().replace(/[^A-Z0-9]/g, ''); }
      var helmetSize = sizeKey(size.value);
      var matches = entries.filter(function (entry) {
        var option = entry.option;
        return entry.input === input && option.getAttribute('data-option1') === color.value &&
          sizeKey(option.getAttribute('data-option2')) === helmetSize &&
          (input.getAttribute('data-ebike-bundle') !== 'winter' || sizeKey(option.getAttribute('data-option3')) === helmetSize);
      });
      if (matches.length !== 1) return null;
      var entry = matches[0];
      var variant = parse(entry.option);
      if (!variant || (entry.option.disabled && variant.available)) return null;
      var helmet = owner.productData.variants.find(function (candidate) {
        return candidate.option1 === color.value && candidate.option3 === size.value &&
          /^mips$/i.test(candidate.option2);
      });
      if (!helmet) return null;
      // Keep native color/gallery semantics while buying the real kit variant.
      variant.options = helmet.options.slice();
      variant.option1 = helmet.option1;
      variant.option2 = helmet.option2;
      variant.option3 = helmet.option3;
      variant.featured_image = helmet.featured_image;
      variant._lumosBundleHandle = input.getAttribute('data-bundle-handle');
      variant._lumosHelmetId = helmet.id;
      variant._lumosPriceText = entry.option.getAttribute('data-price-formatted');
      variant._lumosCompareText = entry.option.getAttribute('data-compare-formatted');
      return variant;
    };

    owner._updateProductPrices = function (variant, previous) {
      var prices = this.element.querySelector('.ProductMeta__PriceList');
      var variants = form.querySelector('.ProductForm__Variants');
      if (prices) prices.classList.remove('has-bundle-product');
      if (variants) variants.classList.remove('has-bundle-product');
      if (!variant || !variant._lumosBundleHandle) return nativePrices.call(this, variant, previous);
      if (!prices) return;
      prices.textContent = '';
      var discounted = variant.compare_at_price > variant.price;
      function add(text, className) {
        var span = global.document.createElement('span');
        span.className = 'ProductMeta__Price Price Text--subdued u-h4 ' + className;
        span.textContent = text;
        prices.appendChild(span);
      }
      if (discounted) add(variant._lumosCompareText, 'Price--compareAt');
      add(variant._lumosPriceText, discounted ? 'Price--highlight' : '');
      prices.style.display = '';
    };

    owner._updateInventory = function (variant) {
      if (!variant || !variant._lumosBundleHandle) return nativeInventory && nativeInventory.apply(this, arguments);
      // Kit availability is authoritative; the helmet inventory table has no kit entry.
      var inventory = this.element.querySelector('.ProductForm__Inventory');
      if (inventory) inventory.style.display = 'none';
    };

    owner._updateHistoryState = function (variant) {
      if (!variant || !variant._lumosBundleHandle) return nativeHistory.apply(this, arguments);
      var url = new URL(global.location.href);
      url.searchParams.set('variant', String(variant._lumosHelmetId));
      url.searchParams.set('selectBundle', variant._lumosBundleHandle);
      global.history.replaceState({ path: url.href }, '', url.href);
    };

    var saved = new URL(global.location.href).searchParams.get('selectBundle') || marker.dataset.preselect;
    var preselected = inputs.filter(function (input) { return input.getAttribute('data-bundle-handle') === saved; });
    var selected = inputs.filter(function (input) { return input.checked; });
    if ((saved && preselected.length === 1) || selected.length === 1) {
      var input = saved && preselected.length === 1 ? preselected[0] : selected[0];
      input.checked = true;
      owner._onOptionChanged(null, input);
    }
  }
  global.LumosEbikeBundles = { bind: bind };
  (global.lumosEbikeBundleOwners || []).forEach(bind);
  delete global.lumosEbikeBundleOwners;
})(window);
